"use client";

import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarHeader,
  SidebarMenu,
  SidebarSeparator,
} from "@/components/ui/sidebar";
import { cn } from "@/utils/utils";
import * as React from "react";
import { HelpSidebarButton } from "../help-sidebar-button";
import { GettingStartedWidget } from "../getting-started/getting-started-widget";

interface AppShellSidebarProps extends React.ComponentProps<typeof Sidebar> {
  id: string;
  header: React.ReactNode;
  footer?: React.ReactNode;
  children: React.ReactNode;
}

export const AppShellSidebar = ({
  id,
  header,
  footer,
  children,
  className,
  ...props
}: AppShellSidebarProps) => {
  return (
    <Sidebar
      id={id}
      variant="inset"
      collapsible="offcanvas"
      className={cn("p-0 pt-3", className)}
      {...props}
    >
      <SidebarHeader className="px-3 pb-1 pt-0">{header}</SidebarHeader>
      <SidebarContent className="gap-3 px-3 pb-1 pt-3">
        {children}
        <SidebarGroup className="mt-auto pb-1">
          <SidebarMenu>
            <HelpSidebarButton />
          </SidebarMenu>
          <GettingStartedWidget />
        </SidebarGroup>
      </SidebarContent>
      {footer ? (
        <SidebarFooter className="px-3 pb-3 pt-0">
          <SidebarSeparator className="mx-0" />
          {footer}
        </SidebarFooter>
      ) : null}
    </Sidebar>
  );
};
